import { TCustomization } from 'types/GlobalCustomization'
import { Category, TResourceFilter } from './GlobalDashboardGroup'
import { TCustomFieldValue } from './GlobalCustomFieldValue'

export enum DashboardVariantType {
  API = 'api',
  PORTAL = 'portal',
  PUBLIC = 'public'
}

export type DashboardVariant = {
  embedded: boolean
  type: DashboardVariantType
}

export interface ILayoutItem {
  x: number
  y: number
  w: number
  h: number
}
export interface IShareSettings {
  api_access: boolean
  api_access_link: string
  is_public: boolean
  link: string
  public_link: string
}

export type TDashboard = {
  id: string
  category: {
    selected: Category | null
    options: Category[]
  }
  title: string
  subtitle: string | null
  description: string | null
  thumbnail: string | null
  available_space: ILayoutItem | null
  dashboard_group_id: string
  share_settings: IShareSettings
  custom_field_values: TCustomFieldValue[]
  index: number
  number_of_widgets: number
  updated_at: string
  created_at: string

  // Present i TPublicDashboard
  white_label_settings?: TCustomization
  allow_financial_year?: boolean
  dashboard_filters?: TResourceFilter[]
}

export type TPublicDashboard = Omit<
  TDashboard,
  'white_label_settings' | 'allow_financial_year' | 'dashboard_filters'
> & {
  white_label_settings: TCustomization
  allow_financial_year: boolean
  dashboard_filters: TResourceFilter[]
}

// Type guard to check if dashboard is a public dashboard
export const isPublicDashboard = (
  dashboard: TDashboard | null
): dashboard is TPublicDashboard => {
  if (!dashboard) return false

  return (
    dashboard.white_label_settings !== undefined &&
    dashboard.allow_financial_year !== undefined &&
    dashboard.dashboard_filters !== undefined
  )
}
